/**
 * Simple JavaScript to introduce a menu expander on mobile.
 */
export default (enableDebug = false) => {
	const debug = enableDebug;
	const expanders = document.querySelectorAll('.footer__menu-group-expander');
	const headers = document.querySelectorAll('.footer__menu-group-header');

	if (debug && expanders.length === 0) {
		console.log('No footer navigation expanders found');
	}

	expanders.forEach(expander => {
		if (debug) console.log('found a footer navigation expander');

		expander.addEventListener('click', (event) => {
			event.stopPropagation(); // Prevent event bubbling to header
			toggleMenu(expander);
		});
	});

	headers.forEach(header => {
		header.addEventListener('click', (event) => {
			const expander = header.querySelector('.footer__menu-group-expander');
			if (expander) {
				expander.click(); // Trigger the same event as clicking the expander
			}
		});
	});

	function toggleMenu(expander) {
		if (debug) console.log('user clicked a footer navigation expander');

		const menuGroup = expander.closest('.footer__menu-group');

		if (debug) console.log('parent element: ', menuGroup);

		if (menuGroup) {
			const menuItems = menuGroup.querySelector('.footer__menu-items');

			if (debug) console.log('targeted menu items: ', menuItems);

			if (menuItems) {
				if (!menuItems.classList.contains('--expanded')) {
					expander.classList.add('--expanded');
					menuItems.classList.add('--expanded');
					if (debug) console.log('class "--expanded" added');
				} else {
					expander.classList.remove('--expanded');
					menuItems.classList.remove('--expanded');
					if (debug) console.log('class "--expanded" is already present');
				}
			} else {
				if (debug) console.log('No menu items found within the parent element');
			}
		} else {
			if (debug) console.log('No parent element found with the class "footer__menu-group"');
		}
	}
}
